module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-base-shadow-15.f6887c8c.png";